(() => {
  if (window.seedProductVariantMediaLoaded) return;
  window.seedProductVariantMediaLoaded = true;

  const handleize = (value) =>
    String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const parseMap = (root) => {
    if (root.seedVariantMediaMap) return root.seedVariantMediaMap;

    const script = root.querySelector('[data-seed-variant-media-map]');
    if (!script) {
      root.seedVariantMediaMap = {};
      return root.seedVariantMediaMap;
    }

    try {
      root.seedVariantMediaMap = JSON.parse(script.textContent || '{}');
    } catch (error) {
      root.seedVariantMediaMap = {};
    }

    return root.seedVariantMediaMap;
  };

  const currentVariantId = () => {
    const variantFromUrl = new URLSearchParams(window.location.search).get('variant');
    if (variantFromUrl) return variantFromUrl;

    return document.querySelector('product-info input[name="id"]')?.value || '';
  };

  const selectedColorFromProductForm = () => {
    const selectedLabel = document.querySelector(
      'product-info input[type="radio"]:checked + label[data-seed-variant-color-value]'
    );

    if (selectedLabel?.dataset.seedVariantColorValue) return selectedLabel.dataset.seedVariantColorValue;

    const selectedInput = document.querySelector('product-info .product-form__input--seed-color input[type="radio"]:checked');
    if (selectedInput?.value) return handleize(selectedInput.value);

    return '';
  };

  const colorKeyForRoot = (root, variant) => {
    const map = parseMap(root);
    const variantId = variant?.id ? String(variant.id) : currentVariantId();

    if (variantId && map[variantId]) return map[variantId];

    const optionIndex = Number(root.dataset.seedVariantMediaOptionIndex);
    if (variant?.options && Number.isInteger(optionIndex) && optionIndex >= 0 && variant.options[optionIndex]) {
      return handleize(variant.options[optionIndex]);
    }

    return selectedColorFromProductForm();
  };

  const stopInactiveMedia = (frame) => {
    frame.querySelectorAll('video').forEach((video) => {
      video.pause();
      video.controls = false;
    });
    frame.querySelectorAll('.is-playing').forEach((item) => item.classList.remove('is-playing'));
  };

  const activateGroup = (group, colorKey) => {
    const frames = Array.from(group.children).filter((child) => child.matches('[data-seed-variant-media-frame]'));
    if (!frames.length) return;

    const requestedFrame = colorKey
      ? frames.find((frame) => frame.dataset.seedVariantMediaKey === colorKey)
      : null;
    const fallbackFrame =
      frames.find((frame) => frame.dataset.seedVariantMediaKey === 'default') ||
      frames.find((frame) => frame.dataset.seedVariantMediaDefault === 'true') ||
      frames[0];
    const activeFrame = requestedFrame || fallbackFrame;

    frames.forEach((frame) => {
      const isActive = frame === activeFrame;
      frame.classList.toggle('is-active', isActive);
      frame.toggleAttribute('hidden', !isActive);
      frame.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      if (!isActive) stopInactiveMedia(frame);
    });
  };

  const updateRoot = (root, variant) => {
    const colorKey = colorKeyForRoot(root, variant);
    root.querySelectorAll('[data-seed-variant-media-group]').forEach((group) => activateGroup(group, colorKey));

    window.seedMediaVideoBind?.(root);
  };

  const bind = (container = document, variant = null) => {
    container.querySelectorAll('[data-seed-variant-media-root]').forEach((root) => updateRoot(root, variant));
  };

  window.seedProductVariantMediaBind = bind;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bind());
  } else {
    bind();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => bind(document, data?.variant));
  }

  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
